import React from "react";
import { useSelector } from "react-redux";
import {
    Card,
    CardBody,
    CardTitle,
} from "reactstrap";
import LineApexChart from "./chart"
import CurrencyFormat from 'react-currency-format';

const accountNumberDasbor = () => {
    const { data, loading } = useSelector(state => ({
        data: state.Dashboard.data,
        loading: state.Dashboard.loading,
    }));

    return <>
        {data && data.dataAccountNumbers && !loading &&
            data.dataAccountNumbers.map(item => {
                return < Card key={'accNum' + item.id}>
                    <CardBody>
                        <div className="d-flex mb-3">
                            <div className="flex-grow-1">
                                <CardTitle className="mb-0">{item.name}</CardTitle>
                                <small>{item.number}</small>
                            </div>
                            <div>
                                <small>Balance</small>
                                <CardTitle className="text-end">
                                    <CurrencyFormat value={item.balance ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2}
                                        displayType={'text'} />
                                </CardTitle>
                            </div>
                        </div>
                        <LineApexChart dataColors='["--bs-primary", "--bs-success"]' data={item} />
                    </CardBody>
                </Card>
            })
        }
    </>
}

export default accountNumberDasbor;